import "./Faq.css";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import fotoConsultorio from "../../assets/img/fotoConsultorio.png";

function Faq() {
  const navigate = useNavigate();

  const perguntas = [
    {
      pergunta: "Atende plano de saúde?",
      resposta:
        "Realizamos atendimento exclusivamente particular para garantir o tempo e a qualidade necessários para casos complexos. Fornecemos toda a documentação necessária para que você solicite o reembolso junto ao seu convênio."
    },
    {
      pergunta: "Como funciona a consulta?",
      resposta:
        "O momento da consulta é focado em um atendimento aprofundado, sem pressa, onde revisamos todo o histórico clínico, exames anteriores e discutimos em detalhes as opções terapêuticas e cirúrgicas."
    },
    {
      pergunta: "Onde atende?",
      resposta:
        "Temos consultórios fixos em Teresópolis e no Rio de Janeiro (Botafogo), em estruturas modernas e confortáveis preparadas para receber casos urológicos."
    }
  ];

  return (
    <section className="faq-section" id="faq">
      <div className="container">

        <h2 className="faq-title text-center scroll-reveal-opacity">
          Perguntas Frequentes
        </h2>

        <div className="row justify-content-center">

          <div className="col-12 col-lg-8">

            {perguntas.map((item, index) => (
              <div
                key={index}
                className="faq-item scroll-reveal-opacity"
              >
                <h3>{item.pergunta}</h3>
                <p>{item.resposta}</p>
              </div>
            ))}

          </div>

        </div>

      </div>
    </section>
  );
}

export default Faq;
